const { hostname } = window.location;
const env = { isLocal: hostname.indexOf('localhost') !== -1 };
export default env;
